module.exports = __webpack_public_path__ + "img/Frame 2@2x.d77a0013.png";